﻿import React, { createContext, useState, useMemo } from "react";

export const initWaitingListFlowContext = {
    activeStep: 1,
    introduction: { index: 1 },
    paymentTerm: { index: 2 },
    login: { index: 3 },
    createAccount: { index: 4 },
    vehicle: { index: 5 },
    document: { index: 6 },
    overview: { index: 7 },
    confirmation: { index: 8 },
    facility: null,
    product: null,
    waitingList: null,
    user: null,
    productConfirmed: false
};

export const WaitingListFlowContext = createContext(null);

export const WaitingListFlowContextProvider = (props) => {
    const config = props.appConfig ?? {};
    const urlParams = new URLSearchParams(window.location.search);
    const fId = urlParams.get("fId") ?? urlParams.get("fid");
    const type = urlParams.get("T") ?? urlParams.get("t") ?? "1";
    const sessionName = `__aimo-waitinglist-flow__${fId}__${type}`;
    const expiry = 1000 * 60 * 60;

    const getWithExpiry = (key) => {
        try {
            const itemStr = sessionStorage.getItem(key);
            if (itemStr) {
                const item = JSON.parse(itemStr);
                const now = new Date();
                if (item.expiry && item.expiry > now.getTime()) {
                    delete item.expiry;
                    return item;
                }
                if (!item.expiry) return item;
            }
            Object.keys(sessionStorage).forEach((key) => {
                if (key.includes("__aimo-waitinglist-flow"))
                    sessionStorage.removeItem(key);
            });
            return null;
        } catch (err) {
            console.error("Error reading session storage:", err);
            return null;
        }
    };
    const browserWaitingListFlowState = getWithExpiry(sessionName);

    const [waitingListFlowContext, setWaitingListFlowContextTmp] = useState(
        () => {
            const currentState = browserWaitingListFlowState
                ? { ...browserWaitingListFlowState, ...config }
                : { ...initWaitingListFlowContext, ...config };
            return currentState;
        }
    );

    const setWaitingListFlowContext = (state) => {
        const now = new Date();
        const item = { ...state, expiry: now.getTime() + expiry };
        sessionStorage.setItem(sessionName, JSON.stringify(item));
        if (state.activeStep > waitingListFlowContext.activeStep) {
            history.pushState({ activeStep: state.activeStep }, document.title);
        }
        setWaitingListFlowContextTmp(state);
    };

    const waitingListFlowState = useMemo(
        () => ({ waitingListFlowContext, setWaitingListFlowContext }),
        [waitingListFlowContext, setWaitingListFlowContext]
    );

    return (
        <WaitingListFlowContext.Provider value={waitingListFlowState}>
            {props.children}
        </WaitingListFlowContext.Provider>
    );
};
